// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__34ECW","rootMobile":"styles_rootMobile__2uLTq"};